import { useEffect } from 'react'

import { usePublicClient } from 'wagmi'

import { RPC_LIST } from 'constants/chains'
import { airdropper } from 'services/airdropper'

export function useAirdropper() {
  const { chain } = usePublicClient()

  useEffect(() => {
    airdropper.initAirdropper(chain, RPC_LIST[chain.id])
  }, [chain])

  return airdropper
}
